module.exports = __webpack_public_path__ + "18a76985903a738ed558075d37b50d1f.svg";